import Button from "../Shared/Button";
import Input from "../Shared/Input";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ButtonTypes } from "../../utils/consts";
import { resetpassword } from "../../api/Auth/resetpasswors";
import { useParams } from "react-router-dom";
import { useState } from "react";

const validationSchema = Yup.object({
    newPassword: Yup.string()
        .required("Password is required")
        .matches(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase , One Special Character and One Number"
        ),
    confirmPassword: Yup.string()
        .required("Confirm password is required")
    // .oneOf([Yup.ref("password"), ""], "Passwords must match"),
});

const ResetPasswordForm = () => {
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const { email } = useParams();
    const emailValue = email || "";

    const { mutate, error } = useMutation({
        mutationFn: resetpassword,
        onSuccess: () => {
            setSuccessMessage('Password successfully reset. You will be redirected shortly.');

            setTimeout(() => {
                navigate(`/login`);
            }, 3000);
        },
        onError: () => {
            formik.setSubmitting(false);
        },
    });
    const formik = useFormik({
        initialValues: {
            email: emailValue,
            newPassword: "",
            confirmPassword: "",
        },
        validationSchema,
        onSubmit: (values) => {
            mutate({
                email: values.email, newPassword: values.newPassword,
                confirmPassword: values.confirmPassword
            });
        },
    });

    return (
        <div className="flex flex-col h-full justify-center text-burntBlack">
      <div className="mb-8 md:text-start text-center">
                <h1 className="font-semibold sm:mb-2 mb-1 sm:text-[42px] text-28px">Reset Your Password</h1>
                <p className="font-medium sm:text-xl md:mx-0 mx-auto max-w-[606px]">
                    Please enter new password and make sure its unique
                </p>
            </div>
            <form
                onSubmit={formik.handleSubmit}
                className="flex flex-col gap-5"
                action=""
            >
                <Input
                          inputStyles="md:h-16 h-[52px]"
                    value={formik.values.newPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                        formik.touched.newPassword && formik.errors.newPassword
                            ? formik.errors.newPassword
                            : ""
                    }
                    title="New Password"
                    placeholder="**********"
                    name="newPassword"
                    type="password"
                />
                <Input
                          inputStyles="md:h-16 h-[52px]"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                        formik.touched.confirmPassword && formik.errors.confirmPassword
                            ? formik.errors.confirmPassword
                            : ""
                    }
                    title="Confirm Password"
                    placeholder="**********"
                    name="confirmPassword"
                    type="password"
                />
                <Button type={ButtonTypes.SUBMIT}
                    disabled={formik.isSubmitting}
                    variant="primary" 
                    className="w-full md:mt-3 mt-2  md:h-16 h-[54px]"
                    >
                    Submit
                </Button>
                {successMessage && (
                    <span className="text-green-500 font-medium text-lg mt-3 text-center">
                        {successMessage}
                    </span>
                )}

                {error instanceof AxiosError && (
                    <span className="text-red-500 font-bold text-lg">
                        {error?.response?.data?.message || "An error occurred"}
                    </span>
                )}

            </form>
        </div>
    );
};

export default ResetPasswordForm;
